export default __webpack_public_path__ + "static/media/investmenticon.e5cb26b2.svg";